<template>
  <div class="left">
    <div class="title">当前预警信息</div>
    <div class="warning">
      <div class="item">
        <div class="ileft">
          <div class="name">岗位空缺</div>
          <div class="num">{{ stats.absent_count || 0 }}</div>
        </div>
        <div class="iright">
          <img src="../../assets/xuhui/vacancy.png" class="icon" />
        </div>
      </div>
      <div class="item">
        <div class="ileft">
          <div class="name">换岗超时</div>
          <div class="num">{{ stats.overtime_count || 0 }}</div>
        </div>
        <div class="iright">
          <img src="../../assets/xuhui/vacancy.png" class="icon" />
        </div>
      </div>
      <div class="item">
        <div class="ileft">
          <div class="name">非救生员上岗</div>
          <div class="num">{{ stats.impostor_count || 0 }}</div>
        </div>
        <div class="iright">
          <img src="../../assets/xuhui/vacancy.png" class="icon" />
        </div>
      </div>
      <div class="item">
        <div class="ileft">
          <div class="name">状态不佳</div>
          <div class="num">{{ stats.poor_state_count || 0 }}</div>
        </div>
        <div class="iright">
          <img src="../../assets/xuhui/vacancy.png" class="icon" />
        </div>
      </div>
    </div>
    <div class="title">预警列表</div>
    <div class="table">
      <div class="thead">
        <div class="h-item num">序号</div>
        <div class="h-item jobs">岗位</div>
        <div class="h-item desc">预警详情</div>
        <div class="h-item time">预警时间</div>
      </div>
      <div class="tbody">
        <div class="t-item" v-for="(item, index) in list" :key="index">
          <div class="b-item num">{{ index + 1 }}</div>
          <div class="b-item jobs">{{ item.number }}号</div>
          <div class="b-item desc">{{ item.message }}</div>
          <div class="b-item time">{{ item.created_time.split(' ')[1] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

let timer = null

export default {
  data() {
    return {
      list: [],
      stats: {},
    }
  },
  destroyed() {
    clearInterval(timer)
  },
  mounted() {
    this.get_list()
    this.get_data()

    timer = setInterval(() => {
      this.get_list()
      this.get_data()
    }, 10000)
  },
  methods: {
    get_data() {
      this.$http({
        url: 'api/alarm-stats',
        method: 'get',
        params: {
          sid: this.sid,
          start_time: moment().format('YYYY-MM-DD'),
          end_time: moment()
            .add('day', 1)
            .format('YYYY-MM-DD'),
        },
      }).then((r) => {
        this.stats = r.data
      })
    },
    get_list() {
      this.$http({
        url: 'api/alarm-list',
        method: 'get',
        params: {
          sid: this.sid,
          start_time: moment().format('YYYY-MM-DD'),
          end_time: moment()
            .add('day', 1)
            .format('YYYY-MM-DD'),
        },
      }).then((r) => {
        this.list = r.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.left {
  padding: 16px 20px;
  .title {
    font-size: 18px;
    color: #32c4fe;
    margin-bottom: 18px;
  }
  .warning {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      width: 190px;
      height: 112px;
      background: #002146;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 0 12px;
      margin-bottom: 16px;
      .ileft {
        .name {
          font-size: 20px;
          color: #32c5ff;
          white-space: nowrap;
          width: 80px;
        }
        .num {
          font-size: 38px;
          color: #ffffff;
          margin-top: 6px;
        }
      }
      .iright {
        width: 50px;
        height: 50px;
        margin-top: 12px;
        .icon {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
  .table {
    color: #fff;
    .h-item,
    .b-item {
      width: 25%;
      text-align: center;
      &.num {
        width: 15%;
      }
      &.jobs {
        width: 15%;
      }
      &.desc {
        width: 35%;
      }
      &.time {
        width: 35%;
      }
    }
    .thead {
      display: flex;
      align-items: center;
      font-size: 18px;
      background: #30bff9;
      border-radius: 4px;
      padding: 10px 0;
      color: #fff;
    }
    .tbody {
      height: 510px;
      overflow: auto;
      .t-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        padding: 10px;
        border-bottom: 1px solid #03577e;
        &:nth-of-type(even) {
          background: #244a75;
        }
      }
    }
  }
}
</style>
